<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

defineProps<{
  to: RouteLocationRaw
  label: string
  count?: number | string
}>()
</script>

<template>
  <NuxtLink
    :to="to"
    class="flex items-center justify-between bg-[#F6F6F6] rounded-[10px] p-[18px] active:bg-gray-200 transition-colors">
    <div class="flex items-center space-x-3 text-[16px] text-gray-800">
      <div class="w-1 h-1 bg-gray-800 rounded-full"></div>
      <span
        >{{ label }}<span v-if="count !== undefined">({{ count }})</span></span
      >
    </div>
    <div class="text-gray-400">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-[18px] w-[18px]" viewBox="0 0 20 20" fill="currentColor">
        <path
          fill-rule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clip-rule="evenodd" />
      </svg>
    </div>
  </NuxtLink>
</template>
